"use client"

import React, { useEffect, useState } from "react"
import Cookies from "js-cookie"
import Link from "next/link"

const CONSENT_COOKIE_NAME = "cookie_consent"
const CONSENT_EXP_DAYS = 365 // 1 год

export default function CookieConsent() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        try {
            const consent = Cookies.get(CONSENT_COOKIE_NAME)
            if (!consent) {
                setIsOpen(true)
            }
        } catch {
            // В редких случаях доступ к куки может быть недоступен — просто не показываем
            setIsOpen(false)
        }
    }, [])

    const accept = () => {
        try {
            Cookies.set(CONSENT_COOKIE_NAME, "1", {
                expires: CONSENT_EXP_DAYS,
                sameSite: "Lax",
                secure: typeof window !== "undefined" && window.location.protocol === "https:",
                path: "/",
            })
        } finally {
            setIsOpen(false)
        }
    }

    if (!isOpen) return null

    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-label="Уведомление о куки"
            className="fixed bottom-4 right-4 z-[1000] max-w-[560px] w-[calc(100vw-5rem)]"
        >
            <div className="rounded-2xl bg-[#0B0B0B] text-white shadow-xl">
                <div className="p-6">
                    <div className="text-sm font-bold leading-tight mb-3">
                        Используем куки и рекомендательные технологии
                    </div>
                    <div className="text-xs leading-relaxed text-white/80 mb-3">
                        Это чтобы сайт работал лучше.
                    </div>
                    <div className="text-xs leading-relaxed text-white/80 mb-3">
                        Оставаясь с нами, вы соглашаетесь на использование
                        файлов куки. Подробнее —{" "}
                        <Link href="/legal/cookies" className="underline">
                            файлов куки
                        </Link>
                        .
                    </div>
                    <div className="text-xs leading-relaxed text-white/80">
                        А ещё можно почитать, что такое{" "}
                        <Link href="/legal/cookies" className="underline">
                            рекомендательные технологии
                        </Link>
                        .
                    </div>
                </div>
                <div className="p-6 pt-0">
                    <button
                        type="button"
                        onClick={accept}
                        className="w-full select-none rounded-xl bg-[#1A73FF] px-4 py-3 text-center text-xs font-semibold text-white hover:opacity-90 active:opacity-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#1A73FF] focus-visible:ring-offset-[#0B0B0B]"
                    >
                        ОК
                    </button>
                </div>
            </div>
        </div>
    )
}


